import { render, staticRenderFns } from "./PesquisarCartorio.vue?vue&type=template&id=ec3cce3e&scoped=true&"
import script from "./PesquisarCartorio.vue?vue&type=script&lang=js&"
export * from "./PesquisarCartorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3cce3e",
  null
  
)

export default component.exports